<script>
import { BCardImgLazy } from "bootstrap-vue";

export default {
  extends: BCardImgLazy
};
</script>